import React, { useState } from "react";
import classes from "./NotificationFilter.module.css";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Checkbox } from "../Checkbox/Checkbox";

export const NotificationFilter = ({ data, state, setter, isSelectAll }) => {
  const [selectall, setSelectAll] = useState([]);

  return (
    <div className={[classes.notifyFilterScreen].join(" ")}>
      <h5
        className={[classes.mb24].join(" ")}
        style={{ ...Fonts.h5, color: Colors.neutralShadesOfDimGray }}
      >
        Filter by
      </h5>
      {data?.map((item, i) => {
        return (
          <div className={[classes.mb24].join(" ")} key={i}>
            <Checkbox value={state} setValue={setter} label={item} />
          </div>
        );
      })}
      {isSelectAll && (
        <div className={[classes.selectalldiv].join(" ")}>
          <Checkbox
            value={selectall}
            setValue={(e) => {
              setSelectAll(e);
              console.log(e);
              if (e.includes("Select All") === true) {
                setter(data);
              } else {
                setter([]);
              }
            }}
            label="Select All"
          />
        </div>
      )}
    </div>
  );
};
